import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import {
  EuiSpacer,
  EuiButton,
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
} from "@elastic/eui";

export default function WebUIArticles() {
  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9820QFHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9820QFHD.webp"
                    alt="IN-9820 QFHD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9820 QFHD"
              description="4K QFHD IP Kamera mit PIR-Sensor. Flexible Smarthome Kompatibilität via ONVIF, RTSP, CGI und MQTT. 2160p UHD & Sony STARVIS."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9820QFHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9808QFHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9808QFHD.webp"
                    alt="IN-9808 QFHD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9808 QFHD"
              description="4K QFHD IP Kamera mit PIR-Sensor. Flexible Smarthome Kompatibilität via ONVIF, RTSP, CGI und MQTT. 1440p UHD & Sony STARVIS."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9808QFHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9420WQHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9420WQHD.webp"
                    alt="IN-9420 WQHD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9420 WQHD"
              description="2k+ IP Kamera mit PIR-Sensor. Flexible Smarthome Kompatibilität via ONVIF, RTSP, CGI und MQTT. 1440p WQHD & Sony STARVIS."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9420WQHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9408WQHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9408WQHD.webp"
                    alt="IN-9408 WQHD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9408 WQHD"
              description="2k+ IP Kamera mit PIR-Sensor. Flexible Smarthome Kompatibilität via ONVIF, RTSP, CGI und MQTT. 1440p WQHD & Sony STARVIS."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9408WQHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9020FHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9020HD.webp"
                    alt="IN-9020 Full HD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9020 Full HD"
              description="PTZ IP Kamera mit PIR-Sensor und Autofokus. Flexible Smarthome Kompatibilität via ONVIF, RTSP, CGI und MQTT. 1080p Full HD & hochwertige Nachtsicht."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9020FHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9010FHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9010HD.webp"
                    alt="IN-9010 Full HD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9010 Full HD"
              description="350° Pan, 100° Tilt und 4-fach optischer Zoom garantieren einen umfassenden Rundumschutz. Moderne INSTAR WebUI, MQTT Standardkonformität und vieles mehr verfügbar."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9010FHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-9008FHD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-9008HD.webp"
                    alt="IN-9008 Full HD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-9008 Full HD"
              description="Full HD PoE IP Kamera speziell für den Außeneinsatz. Kein Kabelsalat und ohne Signalverlust. HTTPS und FTPS Verschlüsselung und flexible Smarthome Kompatibilität."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-9008FHD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-7011HD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-7011HD.webp"
                    alt="IN-7011 HD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-7011 HD"
              description="Die IN-7011 HD ist eine wetterfeste Dome-Kamera, die im Innen- und Außenbereich eingesetzt werden kann. Ein Motor ermöglicht die Änderung der Blickrichtung des Objektivs."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-7011HD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-5907HD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-5907HD.webp"
                    alt="IN-5907 HD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-5907 HD"
              description="Die IN-5907 HD ist eine wetterfeste und drahtlose Außenkamera. Dank der eingebauten Hochleistungs-Infrarot-Dioden können Sie bis tief in die Nacht hinein sehen."
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-5907HD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row">
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/FAQs/IN-5905HD/">
                  <StaticImage
                    src="../../images/Search/P_SearchThumb_IN-5905HD.webp"
                    alt="IN-5905 HD"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="IN-5905 HD"
              description="Sie suchen eine kleine Außenkamera? Die brandneue IN-5905HD, im Grunde eine deutlich kleinere Version unseres Flaggschiffs IN-5907HD, ist genau das, wonach Sie suchen!"
              footer={
                <EuiFlexGroup justifyContent="flexEnd">
                  <Link to="/FAQs/IN-5905HD/">
                    <EuiFlexItem grow={false}>
                      <EuiButton size="s" fill>
                        Lesen
                      </EuiButton>
                      <EuiSpacer size="s" />
                    </EuiFlexItem>
                  </Link>
                </EuiFlexGroup>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem></EuiFlexItem>
          <EuiFlexItem></EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
